// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__auQ8u","col":"styles_col__1PTJJ"};